import { useRef, useState } from 'react';
import UseDebounce from '../../helpers/debounce';
import { AdditionalIcon } from '../shared/additionalIcon/additionalIcon';
import { FilterMenuFieldProps } from './types/filterMenuField';
import { ReactComponent as TuneIcon } from "../../icons/tune.svg";
import './filterMenuField.scss';
import { useClickOutside } from '../../hooks/clickOutsideHook';

const FilterMenuField = (props: FilterMenuFieldProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => {
        setIsOpen(false);
    });

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const handleInputChange = (e: any) => {
        props.onChange(e.target.value);
    }

    return (
        <div style={props.style} className={props.className}>
            <div ref={wrapperRef} className={"filter-menu-container"}>
                <div className={"filter-menu-input"} onClick={toggleDropdown}>
                    <label htmlFor={`${props.id}filterInput`} style={{ display: props.hideLabel ? 'none' : 'flex' }}>{props.label}</label>
                    <input id={`${props.id}filterInput`} placeholder={props.placeholder} className={"body-txt-medium"} onChange={UseDebounce(handleInputChange, 500)}/>
                    <div className={props.active ? "filter-menu-icon filter-menu-icon-active" : "filter-menu-icon"}>{AdditionalIcon(TuneIcon, { fill: props.active ? '#FFF' : 'black' })}</div>
                </div>
                <div className="filter-menu-options" style={{ display: isOpen ? "flex" : "none" }}>
                    <div style={{ display: isOpen ? 'grid' : 'none' }} className="filter-menu-options-items">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterMenuField;
